//
if (
	!(
		window.screen.width > 1000 && !/iPhone|iPad|iPod/i.test(navigator.userAgent)
	)
) {
	if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
		document
			.querySelector(".footer__buttons .android-link")
			.classList.add("d-none");
	}
	if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
		document
			.querySelector(".footer__buttons .ios-link")
			.classList.add("d-none");
	}
}

$(document).ready(function () {
	var modal = $("#preOrderModal");
	$(document).on("click", ".preOrderBtn", function (e) {
		e.preventDefault();
		Loader.show();
		var btn = $(this);

		$.ajax({
			url: btn.attr("href"),
			type: "GET",
			dataType: "json",
			success: function (response) {
				if (response.status === "success") {
					modal.find(".modal-body").html(response.html);
					Loader.hide();
					$.magnificPopup.open({
						items: { src: modal, type: "inline" },
						removalDelay: 300,
						mainClass: "mfp-zoom-in",
					});
				}
			},
		});
	});

	$(document).on("submit", "#preOrderForm", function (e) {
		e.preventDefault();
		var form = $(this);

		$.ajax({
			url: form.attr("action"),
			type: "POST",
			data: form.serialize(),
			dataType: "json",
			success: function (response) {
				if (response.status === "success") {
					// костыль для МОРГЕНШТЕРНа
					if (
						response.showId == 66102 ||
						response.showId == 66103 ||
						response.showId == 66104
					) {
						window.location.href = response.url;
					} else {
						modal.find(".modal-body").html(response.html);
					}
				} else if (response.status === "error") {
					modal.find(".modal-body").html(response.html);
				}
			},
		});
	});

	if (window.location.hash) {
		var btnInHash = window.location.hash.indexOf("#preOrderBtn_") === 0,
			btnClassStr = window.location.hash.substr(1),
			btn = $("." + btnClassStr);

		if (btnInHash && btn.length) {
			btn.first().click();
		}
	}
});

$(document).ready(function () {
	$(".cinema__schedule").each(function () {
		var s = $(this);
		var spoilerLen = s.find(".spoiler").length;
		var button = s.find(".cinema__show_more");

		if (spoilerLen >= 5) {
			button.addClass("is-active");
		}
	});

	$("body").on("click", ".cinema__show_more", function () {
		var s = $(this);
		var parent = s.parent();
		var hiddenItems = parent.find(".spoiler:hidden");

		if (hiddenItems.length < 5) {
			$(".cinema__show_more").removeClass("is-active");
		}

		for (var i = 0; i <= 5; i++) {
			$(hiddenItems[i]).slideDown(200);
		}

		return false;
	});

	$(".city-picker").magnificPopup({
		type: "inline",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
	});
});

function html_slide_thumb(data) {
	return (
		'<div class="slide_preview">' +
		'<img src="' +
		data.thumb +
		'" alt="preview">' +
		"</div>"
	);
}

function slick_prev(name) {
	if (name) {
		return (
			'<button type="button" class="slick-prev"><svg class="svg-icon ' +
			name +
			'"><use xlink:href="' +
			baseUrl +
			"img/sprite.svg#" +
			name +
			'"></use></svg></button>'
		);
	} else {
		return '<button type="button" class="slick-prev"></button>';
	}
}

function slick_next(name) {
	if (name) {
		return (
			'<button type="button" class="slick-next"><svg class="svg-icon ' +
			name +
			'"><use xlink:href="' +
			baseUrl +
			"img/sprite.svg#" +
			name +
			'"></use></svg></button>'
		);
	} else {
		return '<button type="button" class="slick-next"></button>';
	}
}

function resize_text(el, length, size) {
	if (el.text().length > length) {
		el.css("font-size", size + "px");
	}
}

function adaptive_font_size(el) {
	$(el).each(function () {
		var text = $(this);
		var window_width = $(window).outerWidth();

		if (window_width >= 768) {
			resize_text(text, 30, 35);
		}

		if (window_width <= 480) {
			resize_text(text, 20, 14);
		}
	});
}
function home_slider(slider) {
	var home_slider = $(slider);
	var slides = home_slider.find(".home_slider__slide");
	var previews_wrap = home_slider.next(".previews_wrap");
	var slider_previews = $('<div class="slider_previews"></div>');
	var autoplay_speed = 6000;
	var autoplay = true;

	// create slider preview
	slides.each(function (index, el) {
		var slide = $(el);
		slider_previews.append(
			html_slide_thumb({
				thumb: slide.data("thumb"),
			})
		);
	});
	previews_wrap.append(slider_previews);

	// init main slider
	home_slider
		.on("init", function (slick) {
			// hide loader
			$(".lds-ellipsis").fadeOut(100);

			// apply slick to slider previews
			slider_previews.slick({
				rows: 0,
				speed: 400,
				slidesToShow: 7,
				slidesToScroll: 1,
				arrows: false,
				prevArrow: slick_prev("left-arrow2"),
				nextArrow: slick_next("right-arrow2"),
				asNavFor: ".home_slider",
				centerPadding: 0,
				focusOnSelect: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 11,
							slidesToScroll: 1,
						},
					},
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 19,
							slidesToScroll: 1,
						},
					},
				],
			});
		})
		.slick({
			rows: 0,
			// dots: true,
			autoplay: autoplay,
			prevArrow: slick_prev("left-arrow2"),
			nextArrow: slick_next("right-arrow2"),
			autoplaySpeed: autoplay_speed,
			speed: 600,
			lazyLoad: "progressive",
			asNavFor: ".slider_previews",
			cssEase: "cubic-bezier(0.165, 0.84, 0.44, 1)",
		})
		.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
			var next_slide = slick.$slides.filter(".slick-current").next();
			var content_small = next_slide.find(".slider_content__small");
			var content_big = next_slide.find(".slider_content__big");
			var content_place = next_slide.find(".slider_content__bottom");

			TweenMax.from(content_small, 1.2, {
				x: "20%",
				opacity: 0,
				ease: Power2.easeOut,
			});
			TweenMax.from(content_big, 1.3, {
				x: "20%",
				delay: 0.1,
				opacity: 0,
				ease: Power2.easeOut,
			});
			TweenMax.from(content_place, 1.25, {
				x: "20%",
				delay: 0.2,
				opacity: 0,
				ease: Power2.easeOut,
			});
		});

	adaptive_font_size(".slider_content__big");
	$(window).on("resize", function () {
		adaptive_font_size(".slider_content__big");
	});
}
(function ($) {
	svg4everybody();

	home_slider(".slider_wrap--desktop .home_slider");
	home_slider(".slider_wrap--mobile .home_slider");

	// SUBMENU
	(function () {
		var link = $(".has-submenu"),
			submenu = $(".desktop_nav__submenu");

		link.click(function () {
			var s = $(this),
				submenu = s.parent().find(".desktop_nav__submenu");

			s.toggleClass("active");
			submenu.toggleClass("desktop_nav__submenu--active");
			return false;
		});

		$("body").click(function (e) {
			if (
				!link.is(e.target) &&
				!submenu.is(e.target) &&
				submenu.has(e.target).length === 0
			) {
				link.removeClass("active");
				submenu.removeClass("desktop_nav__submenu--active");
			}
		});
	})();

	// MOBILE INFO MENU
	$(".info_button").click(function () {
		var s = $(this);
		$(".info_menu").toggleClass("active");
	});

	// MOBILE MAIN MENU
	(function () {
		var button = $(".hamburger"),
			menu = $(".mobile-menu"),
			close = $(".mobile-menu__close");

		button.click(function () {
			menu.toggleClass("mobile-menu--active");
			$(".m-city-select").removeClass("active");
			$(".m-location").hide();
		});

		close.click(function () {
			menu.removeClass("mobile-menu--active");
		});
	})();

	// SUB MENU
	function subMenu() {
		var buttonSubmenu = $(".has-children");

		buttonSubmenu.click(function () {
			var s = $(this),
				submenu = s.parent().find(".subMenu");

			s.toggleClass("has-children--active");
			submenu.slideToggle();

			return false;
		});
	}

	subMenu();

	// SHOW ALL EVENTS IN FOOTER
	(function () {
		var button = $(".showall"),
			col = $(".footer_events__row");

		button.click(function () {
			var s = $(this);

			s.text() === "Показать все" ? s.text("Скрыть") : s.text("Показать все");

			col.each(function () {
				$(this).toggleClass("mini");
			});

			return false;
		});
	})();

	// SLICK SLIDER
	$(".slider-one__body").slick({
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>',
		appendDots: $(".slider-one__controls"),
		autoplay: 5000,
		speed: 800,
		asNavFor: ".slider-one__nav",
		accessibility: false,

		responsive: [
			{
				breakpoint: 980,
				settings: {
					dots: true,
				},
			},
		],
	});

	$(".slider-one__nav").slick({
		slidesToShow: 20,
		slidesToScroll: 1,
		asNavFor: ".slider-one__body",
		infinite: false,
		focusOnSelect: true,
		accessibility: false,
		arrows: false,
		dots: false,
		speed: 800,
	});

	// block info
	(function () {
		var toggle = $(".block-info__title");

		toggle.click(function () {
			var s = $(this),
				block = s.parent(),
				items = block.find(".mob-hidden");

			s.find(".block-info__expand").toggleClass("active");
			items.slideToggle(150);
		});
	})();

	// CAROUSEL
	$(".carousel").slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button type="button" class="slick-prev"><i></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i></i></button>',
		autoplay: 5000,
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 650,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	});

	$(".tabs").on("click", ".option", function () {
		var s = $(this);

		$(".tab-content").hide();
		$(s.data("value")).fadeIn();
		$(".carousel").slick("setPosition");
		$(".tabs__tab").removeClass("clicked");
	});

	$(".tabs__tab").click(function () {
		var s = $(this);

		if (!s.hasClass("clicked")) {
			$(".tab-content").hide();
			$(s.attr("href")).fadeIn();
			$(".carousel").slick("setPosition");
			$(".tabs__tab").removeClass("clicked");
		}

		s.addClass("clicked");

		return false;
	});

	// CAROUSEL TWO
	$(".carousel2").slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: 5000,
		prevArrow: '<button type="button" class="slick-prev"><i></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i></i></button>',
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	});

	// APP EXPAND MORE TEXT
	(function () {
		var button = $(".app-pros__togglemore");

		button.click(function () {
			$(this)
				.parents(".app-pros__text")
				.find(".app-pros__more")
				.slideToggle(200);
		});
	})();

	$(".app-screens").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: 5000,
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>',
		appendArrows: $(".app-gallery__controls"),
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$(".gallery-item, .video-item").magnificPopup({
		type: "image",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
		callbacks: {
			change: function () {
				if (this.isOpen) {
					this.wrap.addClass("mfp-open");
				}
			},
			elementParse: function (item) {
				if (item.el.hasClass("video-item")) {
					item.type = "iframe";
				} else {
					item.type = "image";
				}
			},
		},
		gallery: {
			enabled: true,
		},
	});

	$(".btn--trailer").magnificPopup({
		type: "iframe",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
	});

	$(".schedule-btn").magnificPopup({
		type: "inline",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
	});

	$(".show_on_map").magnificPopup({
		type: "inline",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
	});

	$(".dummy-button").click(function () {
		$.magnificPopup.open({
			items: {
				src: ".ticket-warning",
				type: "inline",
			},
			removalDelay: 300,
			mainClass: "mfp-zoom-in",
		});
	});

	// NICE SELECT INIT
	$("select").niceSelect();

	// DATEPICKER
	// $.datepicker.regional.ru = {
	//     closeText: 'Закрыть',
	//     prevText: '&#x3C;Пред',
	//     nextText: 'След&#x3E;',
	//     currentText: 'Сегодня',
	//     monthNames: [
	//         'Январь',
	//         'Февраль',
	//         'Март',
	//         'Апрель',
	//         'Май',
	//         'Июнь',
	//         'Июль',
	//         'Август',
	//         'Сентябрь',
	//         'Октябрь',
	//         'Ноябрь',
	//         'Декабрь'
	//     ],
	//     monthNamesShort: [
	//         'Янв',
	//         'Фев',
	//         'Мар',
	//         'Апр',
	//         'Май',
	//         'Июн',
	//         'Июл',
	//         'Авг',
	//         'Сен',
	//         'Окт',
	//         'Ноя',
	//         'Дек'
	//     ],
	//     dayNames: [
	//         'воскресенье',
	//         'понедельник',
	//         'вторник',
	//         'среда',
	//         'четверг',
	//         'пятница',
	//         'суббота'
	//     ],
	//     dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
	//     dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
	//     weekHeader: 'Нед',
	//     dateFormat: 'dd.mm.yy',
	//     firstDay: 1,
	//     isRTL: false,
	//     showMonthAfterYear: false,
	//     yearSuffix: ''
	// };
	//
	// $.datepicker.regional.uk = {
	//     closeText: 'Закрити',
	//     prevText: '&#x3C;Попер',
	//     nextText: 'Наступ&#x3E;',
	//     currentText: 'Сьогодні',
	//     monthNames: [
	//         'Cічень',
	//         'Лютий',
	//         'Березень',
	//         'Квітень',
	//         'Травень',
	//         'Червень',
	//         'Липень',
	//         'Серпень',
	//         'Вересень',
	//         'Жовтень',
	//         'Листопад',
	//         'Грудень'
	//     ],
	//     monthNamesShort: [
	//         'Cіч',
	//         'Лют',
	//         'Бер',
	//         'Квіт',
	//         'Трав',
	//         'Черв',
	//         'Лип',
	//         'Серп',
	//         'Вер',
	//         'Жовт',
	//         'Лист',
	//         'Груд'
	//     ],
	//     dayNames: [
	//         'неділя',
	//         'понеділок',
	//         'вівторок',
	//         'середа',
	//         'четвер',
	//         'п\'ятниця',
	//         'субота'],
	//     dayNamesShort: ['нед', 'пон', 'вівт', 'сер', 'четв', 'п\'ятн', 'суб'],
	//     dayNamesMin: ['НД', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
	//     weekHeader: 'Нед',
	//     dateFormat: 'dd.mm.yy',
	//     firstDay: 1,
	//     isRTL: false,
	//     showMonthAfterYear: false,
	//     yearSuffix: ''
	// };
	//
	// $.datepicker.setDefaults($.datepicker.regional.ru);

	// SE-text SHOW CONTENT
	(function () {
		var seo = $(".se-text");

		seo.each(function () {
			var s = $(this),
				button = s.find(".se-text__btn"),
				content = s.find(".se-text__content");

			button.click(function () {
				button.toggleClass("active");
				content.toggleClass("short");
				return false;
			});
		});
	})();

	// SHOW AFISHA TEXT
	(function () {
		var showBtn = $(".afisha-about__btn");
		var originalText = showBtn.find("span").text();

		if ($(".content_cut").height() > 250) {
			showBtn.show();
		}

		showBtn.click(function () {
			var s = $(this);
			var hideText = s.data("hide_text");
			var currentText = s.find("span").text();

			s.toggleClass("opened");
			$(".content_cut").toggleClass("short");

			s.find("span").text(
				currentText === originalText ? hideText : originalText
			);

			return false;
		});
	})();

	// ACCORDION AND SPOILER
	(function () {
		var acc = $(".accordion__head");
		var spoiler = $(".spoiler__head");

		acc.each(function () {
			var s = $(this);
			if (s.hasClass("active")) {
				s.addClass("active").next().slideDown();
			}
		});

		acc.click(function () {
			var s = $(this);
			if (!s.hasClass("active")) {
				acc.removeClass("active").next().slideUp();
				s.addClass("active").next().slideDown();
			} else {
				s.removeClass("active").next().slideUp();
			}
		});

		spoiler.click(function () {
			var s = $(this);
			s.toggleClass("active").next().slideToggle();
		});
	})();

	// FANCE CLICK
	$.fn.fancyClick = function () {
		this.each(function () {
			var s = $(this),
				circle = $("<span></span>");

			s.prepend(circle);

			s.click(function (e) {
				var offset = s.offset();

				pos = {
					left: e.pageX - offset.left,
					top: e.pageY - offset.top,
				};
				circle
					.css({
						left: pos.left,
						top: pos.top,
					})
					.addClass("grow");
			});

			circle.on(
				"webkitAnimationEnd oanimationend msAnimationEnd animationend",
				function () {
					circle.removeClass("grow");
				}
			);
		});

		return this;
	};

	$(".choose_date").fancyClick();
	$(".desktop_nav__item>a").fancyClick();

	$(".slider2").slick({
		autoplay: 5000,
		prevArrow: '<button type="button" class="slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-next"></button>',
		asNavFor: ".slider2_nav",
	});
	$(".slider2_nav").slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: ".slider2",
		arrows: false,
		focusOnSelect: true,
	});

	// TOGGLE PLACE VIEW
	(function () {
		var button = $(".toggle_view"),
			originalText = button.find("span").text();
		(block = $(".place_head_wrapper")),
			(min = $(".pl_head_min")),
			(max = $(".pl_head_max"));

		function st(val) {
			$("body, html").animate(
				{
					scrollTop: val,
				},
				400
			);
		}

		button.click(function () {
			var s = $(this);
			var currentText = s.find("span").text();
			var hideText = s.data("hide_text");

			st(block.offset().top - 40);

			s.toggleClass("active").hide();

			s.find("span").text(
				currentText === originalText ? hideText : originalText
			);

			min.slideToggle();
			max.slideToggle(function () {
				s.fadeIn();
			});

			if (!max.hasClass("slick_initialized")) {
				$(".slider2").slick("setPosition");
				$(".slider2_nav").slick("setPosition");
			}

			max.addClass("slick_initialized");
		});
	})();

	// Быстрый поиск
	(function () {
		var filter = $(".loc_filter");

		filter.each(function () {
			var s = $(this),
				searchBox = s.find(".loc_searchbox"),
				items = s.find(".loc_item");

			searchBox.keyup(function () {
				var s = $(this),
					value = s.val().toLowerCase();

				if (value != "") {
					items.each(function () {
						var s = $(this);
						var title = s.find(".loc_item__title");

						if (title.text().toLowerCase().indexOf(value) > -1) {
							s.show();
						} else {
							s.hide();
						}
					});
				} else {
					items.show();
				}
			});
		});
	})();

	// site tabs
	(function () {
		var tab = $(".site_tabs a");
		var tabContent = $(".site_tab_content");

		tab.on("click", function () {
			var s = $(this),
				target = s.attr("href");

			if (!s.hasClass("active")) {
				tab.removeClass("active");
				s.addClass("active");
				tabContent.hide();
				$(target).fadeIn(300);
			}

			return false;
		});
	})();

	// open places filter button
	(function () {
		var overlay = $('<div class="overlay"></div>');
		button = $(".show-place-filter");

		function calculateButtonPosition() {
			var attachTarget = $(".breadcrumbs");

			if (attachTarget.length != 0) {
				var top = attachTarget.offset().top;
				var left = 15;

				if ($(window).scrollTop() > top) {
					button.css({
						position: "fixed",
						top: 0,
						right: left,
					});
					button.addClass("fixed");
				} else {
					button.css({
						position: "absolute",
						top: top,
						right: left,
					});
					button.removeClass("fixed");
				}

				button.fadeIn();
			}
		}

		$(window).on("load resize scroll", function () {
			if ($(this).outerWidth() <= 960) {
				calculateButtonPosition();
			} else {
				button.hide();
			}
		});

		button.click(function () {
			$(".layout__sidebar").addClass("active");
			$("body").append(overlay);
			$("html").addClass("no-scroll");
		});

		// close places filter
		$(".pl-filter__close").click(function () {
			$(".layout__sidebar").removeClass("active");
			$("html").removeClass("no-scroll");
			overlay.remove();
		});
	})();

	// tour list
	$(".tour-list ul").each(function () {
		var li = $(this).find("li");

		if (li.length > 7) {
			$(".tour-toggle").fadeIn(150);
		}
	});

	$(".tour-toggle").on("click", function () {
		var parent = $(this).parents(".cat_item");

		if (!parent.hasClass("list-open")) {
			console.log("ADD CLASS!!!!!!!!");
			$(".cat_item").removeClass("list-open");
			parent.addClass("list-open");
		} else {
			$(".cat_item").removeClass("list-open");
		}
	});

	$(".banner-slider").slick({
		slidesToShow: 1,
		prevArrow: '<button type="button" class="slick-prev"><i></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i></i></button>',
	});

	// kassa page new selector
	$(".city-selector__current").on("click", function () {
		var parent = $(this).parent();
		if (!parent.hasClass("opened")) {
			parent.addClass("opened");
		} else {
			parent.removeClass("opened");
		}
	});

	$(document).on("click", function (e) {
		if ($(e.target).closest(".city-selector").length === 0) {
			$(".city-selector").removeClass("opened");
		}
	});

	$(".city-selector__list a").on("click", function (e) {
		e.preventDefault();
		var s = $(this);
		var current = $(".city-selector__current");
		var clicked_text = s.text();
		var clicked_target = s.attr("href");
		if (clicked_target === "#" || $(clicked_target).length === 0) {
			alert("Wrong href value!");
			return;
		}
		if (current.text() != clicked_text) {
			current.text(clicked_text);
			$(".city-selector").removeClass("opened");
			$(".tab-content").hide();
			$(clicked_target).fadeIn();
		} else {
			$(".city-selector").removeClass("opened");
		}
	});

	// nav menu dropdown
	$(document).on("click", ".nav-dd__button", function () {
		var _ = $(this);
		var li = _.parent();
		var list = _.find(".nav-dd__list");
		if (!li.hasClass("active")) {
			li.addClass("active");
		} else {
			li.removeClass("active");
		}
	});

	$(document).on("click", function (e) {
		if ($(e.target).closest(".nav-dd").length === 0) {
			$(".nav-dd").removeClass("active");
		}
	});

	$(".open-popup-link").magnificPopup({
		type: "inline",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
	});

	// sticky header
	$(document).on("scroll load", function () {
		var $header = $(".header_main");

		if ($(window).scrollTop() > 32) {
			$header.addClass("sticky-header");
		} else {
			$header.removeClass("sticky-header");
		}
	});

	$(".comments-link").on("click", function (e) {
		e.preventDefault();
		$("html, body").animate(
			{
				scrollTop: $($.attr(this, "href")).offset().top - 200,
			},
			500
		);
	});

	$(".home-selections").on("mousewheel DOMMouseScroll", function (event) {
		var delta = Math.max(
			-1,
			Math.min(1, event.originalEvent.wheelDelta || -event.originalEvent.detail)
		);
		$(this).scrollLeft($(this).scrollLeft() - delta * 40);
		event.preventDefault();
	});

	$(".mobile-menu__tab").on("click", function (e) {
		e.preventDefault();

		var target = $(this).attr("href");
		$(".mobile-menu__nav").hide();
		$(".mobile-menu__tab").removeClass("active");
		$(this).addClass("active");
		$(target).fadeIn(150);
	});

	$(".m-city-select").on("click", function (e) {
		e.preventDefault();
		$(this).toggleClass("active");
		$(".m-location").toggle();
	});

	function show_current_country(selected_city) {
		var cities = $(selected_city).data("cities");
		var select_country_button = $(".btn-select-country");
		if (!cities) {
			return;
		}
		$(".m-location__item").removeClass("is-current");
		$(selected_city).addClass("is-current");
		var $country_list = $("#country-list");
		$country_list.hide();
		var html = $('<div class="row"></div>');
		cities.forEach(function (item) {
			html.append(
				'<div class="col-6"><a class="m-location__item" href="' +
					item.url +
					'">' +
					item.name +
					"</a></div>"
			);
		});
		$country_list.after(html);
		$(".m-location__current").text($(selected_city).text());
		select_country_button
			.removeClass("active")
			.text(select_country_button.data("text"));
	}

	show_current_country($(".m-location__item.is-current"));

	$("#country-list").on("click", ".m-location__item", function (e) {
		e.preventDefault();
		show_current_country(this);
	});
	$(".btn-select-country").on("click", function (e) {
		e.preventDefault();
		if (!$(this).hasClass("active")) {
			$(".m-location__list .row").not("#country-list").remove();
			$("#country-list").show();
			$(this).addClass("active").text($(this).data("back"));
		} else {
			show_current_country($(".m-location__item.is-current"));
			$("#country-list").hide();
			$(this).removeClass("active").text($(this).data("text"));
		}
	});

	$(document).on("click", ".question-item__title", function () {
		var $parent = $(this).parent();
		if (!$parent.hasClass("active")) {
			$($parent).addClass("active");
			$(this).next(".question-item__body").slideDown(150);
		} else {
			$($parent).removeClass("active");
			$(this).next(".question-item__body").slideUp(150);
		}
	});

	//start of header locations logic
	class LocationLinks {
		constructor() {
			this.locationBtnActive = false;
			this.selectedCountry = $("#country-select").data("selected");
			this.selectedCity = "";

			this.countryInput = $("#country-select");
			this.countryInputMobile = $("#country-select-mobile");
			this.options = [...$(".location-menu__select-city option")];
			this.cityInputDesktop = $("#city-select");
			this.cityInputMobile = $("#city-select-mobile");
			this.changeLocationBtns = $(".location-menu__btn");
			this.locationHeaderButton = $(".location-menu__header, .m-city-select");
			this.locationDropdown = $(".location-menu");

			this.changeCountry();
			this.eventListeners();
		}

		updateInputs() {
			$("#country-select").niceSelect("update");
			$("#country-select-mobile").niceSelect("update");
			$("#city-select").niceSelect("update");
			$("#city-select-mobile").niceSelect("update");
		}

		dropValues() {
			$("#city-select").val(" ");
			$("#city-select-mobile").val(" ");
		}

		changeCountry() {
			this.countryInput.val(this.selectedCountry);
			this.countryInputMobile.val(this.selectedCountry);
			this.options.forEach((city) => {
				city.disabled =
					city.dataset.country == this.selectedCountry ? false : true;
			});
			this.updateInputs();
		}

		handleCountryChange(e) {
			this.selectedCountry = e.target.value;
			this.dropValues();
			this.changeCountry();
		}

		handleCityChange = (e) => {
			this.selectedCity = e.target.value;

			this.cityInputDesktop.val(this.selectedCity);
			this.cityInputMobile.val(this.selectedCity);

			this.updateInputs();
		};

		changeLocation = () => {
			if (this.selectedCity) {
				window.location.href = this.selectedCity;
			}
		};

		toggleCountrySwitcher = () => {
			this.locationBtnActive = !this.locationBtnActive;

			if (this.locationBtnActive) {
				[...this.locationDropdown, ...this.locationHeaderButton].forEach(
					(dropdown) => {
						dropdown.classList.add("active");
					}
				);
			} else {
				[...this.locationDropdown, ...this.locationHeaderButton].forEach(
					(dropdown) => {
						dropdown.classList.remove("active");
					}
				);
			}
		};

		locationModalBlur(e) {
			var excludeClasses = ".location-menu, .m-city-select, .nice-select";
			if ($(e.target).closest(excludeClasses).length > 0) {
				return false;
			}
			if (this.locationBtnActive) {
				this.toggleCountrySwitcher();
			}
		}

		eventListeners() {
			this.countryInput.on("change", this.handleCountryChange.bind(this));
			this.countryInputMobile.on("change", this.handleCountryChange.bind(this));
			this.cityInputDesktop.on("change", this.handleCityChange.bind(this));
			this.cityInputMobile.on("change", this.handleCityChange.bind(this));
			$(document).on("click", this.locationModalBlur.bind(this));

			[...this.changeLocationBtns].forEach((button) => {
				button.addEventListener("click", this.changeLocation.bind(this));
			});
			[...this.locationHeaderButton].forEach((button) => {
				button.addEventListener("click", this.toggleCountrySwitcher.bind(this));
			});
		}
	}
	new LocationLinks();

	//end of header locations logic

	$.fn.datepicker.language["en"] = {
		days: [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday",
		],
		daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
		months: [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		],
		monthsShort: [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		],
		today: "Today",
		clear: "Clear",
		dateFormat: "dd.mm.yyyy",
		timeFormat: "hh:ii",
		firstDay: 1,
	};
	$.fn.datepicker.language["uk"] = {
		days: [
			"Неділя",
			"Понеділок",
			"Вівторок",
			"Середа",
			"Четвер",
			"П'ятниця",
			"Субота",
		],
		daysShort: ["Нед", "Пнд", "Вів", "Срд", "Чтв", "Птн", "Сбт"],
		daysMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
		months: [
			"Січень",
			"Лютий",
			"Березень",
			"Квітень",
			"Травень",
			"Червень",
			"Липень",
			"Серпень",
			"Вересень",
			"Жовтень",
			"Листопад",
			"Грудень",
		],
		monthsShort: [
			"Січ",
			"Лют",
			"Бер",
			"Кві",
			"Тра",
			"Чер",
			"Лип",
			"Сер",
			"Вер",
			"Жов",
			"Лис",
			"Гру",
		],
		today: "Сьогодні",
		clear: "Очистити",
		dateFormat: "dd.mm.yyyy",
		timeFormat: "hh:ii",
		firstDay: 1,
	};

	$(document).ready(function () {
		$(".button-month").click(function () {
			$(".dropdown-month a").removeClass("clicked");
			$(".dropdown-month a").children("span").removeClass("clicked");
			$(".arrow").toggleClass("open");
			$(".dropdown-month").toggleClass("open");
		});

		$(".dropdown-month a").click(function () {
			$(".dropdown-month a").removeClass("clicked");
			$(".dropdown-month a").children("span").removeClass("clicked");
			$(this).toggleClass("clicked");
			$(this).children("span").toggleClass("clicked");
		});
	});
})(jQuery);

//# sourceMappingURL=main.js.map
